
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsQRPromptPayGrid extends Serenity.EntityGrid<PsQRPromptPayRow, any> {
        protected getColumnsKey() { return PsQRPromptPayColumns.columnsKey; }
        protected getDialogType() { return PsQRPromptPayDialog; }
        protected getIdProperty() { return PsQRPromptPayRow.idProperty; }
        protected getInsertPermission() { return PsQRPromptPayRow.insertPermission; }
        protected getLocalTextPrefix() { return PsQRPromptPayRow.localTextPrefix; }
        protected getService() { return PsQRPromptPayService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}